<template>
  <div>
    <div class="h2">
      Prélèvement des cotisations
    </div>

    <!-- Périodicité des prélèvements -->
    <InputSelect
      label="Périodicité des prélèvements"
      slug="fractionnement"
      :model="fractionnement"
      :options="fractionnements"
      :v$="v$"
      @input="$emit('update:fractionnement', $event.target.value)"
    />

    <!-- Date du prélèvement -->
    <InputSelect
      label="Date du prélèvement"
      slug="jourPrelevement"
      :model="jourPrelevement"
      :options="joursPrelevement"
      :v$="v$"
      @input="$emit('update:jourPrelevement', $event.target.value)"
    />

    <!-- Date d'effet -->
    <InputText
      label="Date d'effet"
      slug="dateEffet"
      :disabled="true"
      :model="dateEffet"
      :v$="v$"
      @input="$emit('update:dateEffet', $event.target.value)"
    />
  </div>
</template>

<script>

import useVuelidate from '@vuelidate/core'
import {required, serverError} from "src/modules/shared/validators/validators";
import {computed } from "vue";
import InputText from "src/modules/shared/components/Form/InputText";
import InputSelect from "src/modules/shared/components/Form/InputSelect";

export default {
  name: "ContributionInformationForm",
  components: {
    InputSelect,
    InputText,
  },
  props: {
    serverErrors: {
      type: Array,
      required: true
    },
    fractionnement: {
      type: String,
      required: true
    },
    fractionnements: {
      type: Array,
      required: true
    },
    jourPrelevement: {
      type: String,
      required: true
    },
    joursPrelevement: {
      type: Array,
      required: true
    },
    dateEffet: {
      type: String,
      required: true
    }
  },
  emits: [
    'update:fractionnement',
    'update:jourPrelevement',
    'update:dateEffet'
  ],
  setup (props) {
    const validations = computed(() => ({
      fractionnement: {
        required,
        serverError: serverError(props, 'fractionnement')
      },
      jourPrelevement: {
        required,
        serverError: serverError(props, 'jourPrelevement')
      },
      dateEffet: {
        required,
        serverError: serverError(props, 'dateEffet')
      },
    }))

    const v$ = useVuelidate(validations, props)

    return { v$ }
  },
  watch: {
    serverErrors () {
      this.v$.$reset()
      this.v$.$touch()
    }
  },
}
</script>

<style scoped>

</style>
